// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/event-card/event-card.component.scss
// module id = 524
// module chunks = 0